import React from 'react'

import styles from './message.module.scss'

type Color = 'blue' | 'red' | 'green' | 'yellow' | 'orange'

type Props = {
  color?: Color

  header?: string
  list?: string[]
  content?: React.ReactNode
}

const Colors: Record<Color, string> = {
  blue: styles.blue,
  green: styles.green,
  red: styles.red,
  yellow: styles.yellow,
  orange: styles.orange,
}

const Message = ({ color, header, content, list }: Props) => {
  const colorClassName = color ? Colors[color] : ''

  return (
    <div className={`${styles.message} ${colorClassName}`}>
      {header && <div className={styles.header}>{header}</div>}
      {content && <p className={styles.content}>{content}</p>}
      {list && (
        <ul>
          {list.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default Message
